import { useContext } from "react";
import { PickupLocationContext } from "../store/PickupLocationContext";
import { SeasonContext } from "../store/SeasonContext";
import { ModalContext } from "../store/ModalContext";
type PickupLocationListProps = {
  onEdit: (id: string) => void;
};
//TODO they can't be edited if application periods are open.
const PickupLocationList = ({ onEdit }: PickupLocationListProps) => {
  const { pickupLocations } = useContext(PickupLocationContext);
  const { areWeInSeason } = useContext(SeasonContext);
  const { openModal } = useContext(ModalContext);
  const currentPickupLocations = pickupLocations.map((location) => {
    const days = location.days.map((day, index) => {
      return (
        <span key={day.day} className={`capitalized ${day.day}-pickup`}>
          {day.day} ({day.startTime} - {day.endTime})
        </span>
      );
    });

    return (
      <li
        key={location._id}
        className="wrapper-card green"
        onClick={() => {
          areWeInSeason ? handleCannotEditWarning() : onEdit(location._id);
        }}
      >
        <h3>{location.name}</h3>
        <div
          className={
            areWeInSeason ? "info-card" : "info-card info-card-clickable"
          }
        >
          <p className="pickup-days-display">{days}</p>
          <p>{location.address}</p>
        </div>
      </li>
    );
  });

  function handleCannotEditWarning() {
    openModal({
      title: "WARNING",
      body: "You cannot create or edit pickup locations during the season.",
      showCloseButton: true,
    });
  }

  return (
    <>
      <div className="pickup-location-list">
        <ul>{currentPickupLocations}</ul>
      </div>
    </>
  );
};
export default PickupLocationList;
